import { render } from "./ObjectiveDeleteModal.vue?vue&type=template&id=f2095418"
import script from "./ObjectiveDeleteModal.vue?vue&type=script&lang=js"
export * from "./ObjectiveDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__